import {useMutation, useQueryClient} from '@tanstack/react-query'
import {useSnackbar} from 'notistack'
import {useAuth} from 'src/contexts/AuthContext'
import api, {CreateOrEditClient} from 'src/services/api'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'
import handleErrorWithSnackbar from 'src/utilities/handleErrorWithSnackbar'

export default function useCreateClient() {
  const {enqueueSnackbar} = useSnackbar()
  const client = useQueryClient()
  const {refreshToken} = useAuth()

  const mutation = useMutation({
    mutationKey: [QueryKeyEnum.CREATE_CLIENT],
    mutationFn: async (body: CreateOrEditClient) => {
      await api.client.createOne({
        clientName: body.clientName,
        email: body.email,
        sigmaAccount: body.sigmaAccount,
        moniClientInfo: body.moniClientInfo,
        companyId: body.companyId,
        onePortariaClientInfo: body.onePortariaClientInfo,
        daysToRetainEvents: body.daysToRetainEvents,
        daysToRetainImagens: body.daysToRetainImagens,
        daysToRetainStream: body.daysToRetainStream,
      })
    },
    onSuccess: async () => {
      await refreshToken()
      await client.invalidateQueries({queryKey: [QueryKeyEnum.CLIENTS]})
      enqueueSnackbar('Cliente criado com sucesso', {variant: 'success'})
    },
    onError: (error) => {
      handleErrorWithSnackbar(enqueueSnackbar, error, 'Não conseguimos criar o cliente no momento')
    },
  })
  return mutation
}
